import React from 'react'
import useMobile from '../../../../hooks/useMobile'
import { useLiveDataView } from './hooks/useLiveDataView'
import LiveDataViewDesktop from './components/LiveDataViewDesktop'
import LiveDataViewMobileView from './components/LiveDataViewMobileView'

const LiveDataView = ({ plantData, token }) => {
  const isMobile = useMobile()
  const logic = useLiveDataView(plantData, token)

  if (isMobile) {
    return <LiveDataViewMobileView logic={logic} />
  }

  return <LiveDataViewDesktop logic={logic} />
}

export default LiveDataView
